.root {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  color: var(--color-brand-primary);
  opacity: 0.05;
  pointer-events: none;
}

.edges {
  animation: dash 24s linear infinite;
}

.nodes circle {
  animation: pulse 5s ease-in-out infinite;
}

@keyframes dash {
  from {
    stroke-dasharray: 4 3;
    stroke-dashoffset: 0;
  }
  to {
    stroke-dasharray: 4 3;
    stroke-dashoffset: -140;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .edges,
  .nodes circle {
    animation: none;
  }
}
